import PropTypes from 'prop-types'
import { Button } from '@chakra-ui/react'

export const PrimaryButton = ({
  children,
  isDisabled,
  p = '0px',
  width = '100%',
  height = '44px',
  fontSize = '14px',
  variant = 'solid',
  leftIcon,
  rightIcon,
  ...props
}) => {
  return (
    <Button disabled={isDisabled} colorPalette="primary" p={p} width={width} height={height} fontSize={fontSize} variant={variant} {...props}>
      {leftIcon}
      {children}
      {rightIcon}
    </Button>
  )
}

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool,
  p: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fontSize: PropTypes.string,
  variant: PropTypes.string,
}
